import type { SVGProps } from 'react';

export function PhantomIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.603 21c2.808 0 4.917-2.399 6.177-4.294-.154.419-.239.838-.239 1.24 0 1.108.647 1.896 1.923 1.896 1.752 0 3.624-1.51 4.594-3.136a2.4 2.4 0 0 0-.102.654c0 .771.442 1.258 1.344 1.258 2.842 0 5.7-4.949 5.7-9.277C23 5.97 21.265 3 16.909 3 9.252 3 1 12.193 1 18.131 1 20.463 2.276 21 3.603 21M14.271 8.972c0-.839.477-1.426 1.174-1.426.681 0 1.157.587 1.157 1.426s-.476 1.443-1.157 1.443c-.697 0-1.174-.604-1.174-1.443m3.642 0c0-.839.476-1.426 1.174-1.426.68 0 1.157.587 1.157 1.426s-.477 1.443-1.157 1.443c-.698 0-1.174-.604-1.174-1.443" />
    </svg>
  );
}
